import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getStates} from "../services/LocationService";

export function useStates(businessUnitCode, countryCode, enabled = true, callback = () => {}) {
    const [states, setStates] = useState([]);

    const {data} = useQuery({
        queryKey: ["states", businessUnitCode, countryCode],
        queryFn: () => getStates({businessUnitCode, countryCode}),
        retry: false,
        enabled: enabled && !!businessUnitCode && !!countryCode,
    });

    useEffect(() => {
        if (data) {
            const newStates = data.map((o) => ({id: o.abbreviation, name: o.name}));
            setStates(newStates);
            callback(newStates);
        }
    }, [data]);

    return states;
}
